<script lang="ts">
	import Recruitment from "../../organisms/settings/Recruitment.svelte";
</script>

<div class="flex">
	<div class="flex-1 mr-8">
		<Recruitment/>
	</div>
</div>